import "./_slider-products.scss";

import Swiper from "swiper/bundle";

document.addEventListener("DOMContentLoaded", () => {
  const SliderProducts = document.querySelectorAll(".slider-products");

  SliderProducts.forEach((slider) => {
    new Swiper(slider, {
      loop: false,
      spaceBetween: 15,
      slidesPerView: 1.2,
      // FIX ACCESSIBILITÀ: aggiunge la classe .swiper-slide-visible alle slide attualmente in vista
      watchSlidesProgress: true,
      keyboard: {
        enabled: true,
      },
      // FIX ACCESSIBILITÀ: Attiviamo il modulo di accessibilità nativo di Swiper
      a11y: {
        enabled: true,
        prevSlideMessage: "Slide precedente",
        nextSlideMessage: "Slide successiva",
        slideLabelMessage: "Slide {{index}} di {{slidesLength}}",
      },
      navigation: {
        nextEl: slider
          .closest(".block_slider-products")
          .querySelector(".swiper-button-next-custom"),
        prevEl: slider
          .closest(".block_slider-products")
          .querySelector(".swiper-button-prev-custom"),
      },
      pagination: {
        el: slider
          .closest(".block_slider-products")
          .querySelector(".swiper-pagination"),
        type: "fraction",
      },
      breakpoints: {
        640: { slidesPerView: 2 },
        1024: { slidesPerView: 3, spaceBetween: 30 },
        1200: { slidesPerView: 4, spaceBetween: 30 },
      },
      on: {
        init: function () {
          updateSwiperA11y(this);
        },
        slideChangeTransitionEnd: function () {
          updateSwiperA11y(this);
          announceSlideUpdate(this); // FIX 3: Annuncio vocale
        },
        resize: function () {
          updateSwiperA11y(this);
        },
      },
    });
  });

  // =========================================================
  // FUNZIONI DI SUPPORTO PER ACCESSIBILITÀ
  // =========================================================
  function updateSwiperA11y(swiper) {
    // FIX 1: Assicura che solo le slide visibili ricevano il focus
    swiper.slides.forEach((slide) => {
      // Cerca tutti i link cliccabili dentro la singola slide, ESCLUDENDO l'immagine del prodotto
      const focusableLinks = slide.querySelectorAll("a:not(.product-image)");

      if (slide.classList.contains("swiper-slide-visible")) {
        slide.setAttribute("aria-hidden", "false");
        // Riattiva la navigabilità con il tasto Tab (salta l'immagine)
        focusableLinks.forEach((link) => link.setAttribute("tabindex", "0"));
      } else {
        slide.setAttribute("aria-hidden", "true");
        // FIX 1: Imposta tabindex="-1" per le slide nascoste
        focusableLinks.forEach((link) => link.setAttribute("tabindex", "-1"));
      }
    });

    // FIX 4: Gestione del focus sui bottoni disabilitati
    const nextBtn = swiper.navigation.nextEl;
    const prevBtn = swiper.navigation.prevEl;

    // Funzione interna per disabilitare un bottone logico
    const checkBtnDisabled = (btn) => {
      if (btn) {
        if (btn.classList.contains("swiper-button-disabled")) {
          btn.setAttribute("tabindex", "-1");

          // Se il focus era sul bottone che si è appena disabilitato,
          // spostiamo dinamicamente il focus sulla slide attiva corrente
          if (document.activeElement === btn) {
            swiper.slides[swiper.activeIndex].setAttribute("tabindex", "-1");
            swiper.slides[swiper.activeIndex].focus();
          }
        } else {
          btn.setAttribute("tabindex", "0");
        }
      }
    };

    checkBtnDisabled(nextBtn);
    checkBtnDisabled(prevBtn);
  }

  // FIX 3: Annuncia il cambio di slide allo screen reader (es. "Slide 3 di 5")
  function announceSlideUpdate(swiper) {
    const liveRegionId = "swiper-live-announcer";
    let liveRegion = document.getElementById(liveRegionId);

    // Generiamo un div invisibile ma in ascolto per lo screen reader (aria-live)
    if (!liveRegion) {
      liveRegion = document.createElement("div");
      liveRegion.id = liveRegionId;
      liveRegion.setAttribute("aria-live", "polite");
      liveRegion.style.position = "absolute";
      liveRegion.style.width = "1px";
      liveRegion.style.height = "1px";
      liveRegion.style.overflow = "hidden";
      document.body.appendChild(liveRegion);
    }

    const current = swiper.activeIndex + 1;
    const total = swiper.slides.length;
    liveRegion.textContent = `Slide ${current} di ${total}`;
  }
});
